import React from "react";
import "./footer.css";
import logo from "../../assets/op4.png"

const Footer = () => {
  return (
    <div
      className="footer__container"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gridTemplateRows: "repeat(1, 1fr)",
      }}
    >
      <div className="footer__categories">
        <div >
          <img className="footer__logo" src={logo} alt="logo-website" />
        </div>
      </div>


      <div className="footer__categories">
        <div className="footer__border headertext">
          <h1 className="footer__header">
            MENU
          </h1>
          <ul>
            <li><a href="#about">ABOUT</a></li>
            <li><a href="#service">SERVICES</a></li>
            <li><a href="#portfolio">PORTFOLIO</a></li>
            <li><a href="#contact">CONTACT</a></li>
          </ul>
        </div>
      </div>

      <div className="footer__categories">
        <div className="footer__border headertext">
          <h1 className="footer__header">
          ADDRESS
          </h1>
          <ul>
            <li>Suite #913</li>
            <li>Corporation Building</li>
            <li>Terbang Street</li>
            <li>Malaysia</li>
            <li>Amira</li>
          </ul>
        </div>
      </div>

      <div className="footer__categories">
        <div className="footer__border headertext">
          <h1 className="footer__header">
            CONTACT
          </h1>
          <ul>
            <li>E: info(at)youragency.com</li>
            <li>T: +60 897 123 456</li>
            <li>F: +60 897 123 400</li>
          </ul>
        </div>
      </div>

      
    
    </div>
  );
};

export default Footer;
